import {defineMessages} from 'react-intl';

const t = defineMessages({
  'copy-to-clipboard.client-id-copied': {
    id: 'copy-to-clipboard.client-id-copied',
    defaultMessage: 'The client ID has been copied to the clipboard.',
    description: 'Success message to be displayed when the Client ID is copied to the clipboard'
  },
  'copy-to-clipboard.secret-copied': {
    id: 'copy-to-clipboard.secret-copied',
    defaultMessage: 'The secret has been copied to the clipboard.',
    description: 'Success message to be displayed when the Client ID is copied to the clipboard'
  },
  'client-edit.client-update-successful': {
    id: 'client-edit.client-update-successful',
    defaultMessage: 'Your client\'s data was updated.'
  },
  'client-edit.client-update-failed': {
    id: 'client-edit.client-update-failed',
    defaultMessage: 'We could not update your client. Please try again.'
  },
  'client-edit.client-update-failed-dup-name': {
    id: 'client-edit.client-update-failed-dup-name',
    defaultMessage: 'We could not update your client. The Application Name entered already exists. Please try again.'
  },
  'client-edit.client-add-successful': {
    id: 'client-edit.client-add-successful',
    defaultMessage: 'New client created. Copy and store your client secret now. You won\'t be able to access it later.'
  },
  'client-edit.client-add-failed': {
    id: 'client-edit.client-add-failed',
    defaultMessage: 'We could not add your client. Please try again.'
  },
  'client-edit.client-add-failed-dup-name': {
    id: 'client-edit.client-add-failed-dup-name',
    defaultMessage: 'We could not add your client. The Client name entered already exists. Please try again.'
  },
  'client-edit.client-delete-successful': {
    id: 'client-edit.client-delete-successful',
    defaultMessage: 'Your client was deleted.'
  },
  'client-edit.client-delete-failed': {
    id: 'client-edit.client-delete-failed',
    defaultMessage: 'We could not delete your client. Please try again.'
  },
  'client-info.client-not-found': {
    id: 'client-info.client-not-found',
    defaultMessage: 'Client not found'
  },
  'client-edit.client-secret-key-create-already-present': {
    id: 'client-edit.client-secret-key-create-already-present',
    defaultMessage: 'There\'s already a secret with this name. Enter a unique name.',
  },
  'client-edit.client-secret-key-create.success': {
    id: 'client-edit.client-secret-key-create.success',
    defaultMessage: 'Secret created successfully',
    description: 'Success message to be displayed when the Secret is created successfully'
  },
  'client-edit.client-secret-key-delete': {
    id: 'client-edit.client-secret-key-delete',
    defaultMessage: 'Secret deleted successfully',
    description: 'Success message to be displayed when the Secret is deleted successfully'
  },
  'role-management.role.create.success': {
    id: 'role-management.role.create.success',
    defaultMessage: 'Role added successfully',
    description: 'Success message to be displayed when the Role is created successfully'
  },
  'role-management.role.add.failed': {
    id: 'role-management.role.add.failed',
    defaultMessage: "Couldn't add role. Try again.",
    description: 'Error message to be displayed when the Role creation fails'
  },
  'scope-management.scope.create.success': {
    id: 'scope-management.scope.create.success',
    defaultMessage: 'Scope added successfully',
    description: 'Success message to be displayed when the scope is created successfully'
  },
  'scope-management.scope.add.failed': {
    id: 'scope-management.scope.add.failed',
    defaultMessage: "Couldn't add scope. Try again.",
    description: 'Error message to be displayed when the scope creation fails'
  },
  'role-management.role.edit.success': {
    id: 'role-management.role.edit.success',
    defaultMessage: 'Role edited successfully',
    description: 'Success message to be displayed when the Role is updated successfully'
  },
  'role-management.role.owners.delete.failed': {
    id: 'role-management.role.owners.delete.failed',
    defaultMessage: "Couldn't delete owner. Try again.",
    description: 'Success message to be displayed when the Role is updated successfully'
  },
  'role-management.role.owners.add.failed': {
    id: 'role-management.role.owners.add.failed',
    defaultMessage: "Couldn't add owner. Try again.",
    description: 'Success message to be displayed when the Role is updated successfully'
  },
  'role-management.role.owners.delete.success': {
    id: 'role-management.role.owners.delete.success',
    defaultMessage: "Role owner deleted successfully",
    description: 'Success message to be displayed when the Role is updated successfully'
  },
  'role-management.role.owners.add.success': {
    id: 'role-management.role.owners.add.success',
    defaultMessage: "Role owner added successfully",
    description: 'Success message to be displayed when the Role is updated successfully'
  },
  'role-management.role.already.exists': {
    id: 'role-management.role.already.exists',
    defaultMessage: "Enter a unique ID that isn't currently in use",
    description: 'Error message to be displayed when the Role already exists'
  },
  'role-management.role.id.invalid': {
    id: 'role-management.role.id.invalid',
    defaultMessage: "Enter an ID that doesn't have spaces or special characters other than underscore",
    description: 'Error message to be displayed when the Role ID is invalid'
  },
  'role-management.role.edit.failed': {
    id: 'role-management.role.edit.failed',
    defaultMessage: "Couldn't edit role. Try again.",
    description: 'Error message to be displayed when the Role edit fails'
  },
  'role-management.role.owner.invalid': {
    id: 'role-management.role.owner.invalid',
    defaultMessage: 'Enter a valid email address for the owner',
    description: 'Error message to be displayed when the Role owner email is invalid'
  },
  'client-edit.validation.invalid-scope-id': {
    id: 'client-edit.validation.invalid-scope-id',
    defaultMessage: 'Invalid scope ID',
    description: 'Error message to be displayed when the scope ID is invalid'
  },
  'client-edit.validation.invalid-role-id': {
    id: 'client-edit.validation.invalid-role-id',
    defaultMessage: 'Invalid role ID',
    description: 'Error message to be displayed when the role ID is invalid'
  },
  'client-edit.validation.theme-exceeds-max-length': {
    id: 'client-edit.validation.theme-exceeds-max-length',
    defaultMessage: 'Theme can\'t be more than 100 characters.',
    description: 'Error message to be displayed when the theme field exceeds 100 characters'
  },
  'client-edit.validation.tenant-exceeds-max-length': {
    id: 'client-edit.validation.tenant-exceeds-max-length',
    defaultMessage: 'Tenant can\'t be more than 100 characters.',
    description: 'Error message to be displayed when the tenant field exceeds 100 characters'
  },
  'client-edit.validation.access-token-validity-must-be-number': {
    id: 'client-edit.validation.access-token-validity-must-be-number',
    defaultMessage: 'Access token validity must be a number.',
    description: 'Error message to be displayed when access token validity is not a number'
  },
  'client-edit.validation.refresh-token-validity-must-be-number': {
    id: 'client-edit.validation.refresh-token-validity-must-be-number',
    defaultMessage: 'Refresh token validity must be a number.',
    description: 'Error message to be displayed when refresh token validity is not a number'
  },
  'scope-management.scope.owners.delete.success': {
    id: 'scope-management.scope.owners.delete.success',
    defaultMessage: "Scope owner deleted successfully",
    description: 'Success message to be displayed when the Role is updated successfully'
  },
  'scope-management.scope.owners.add.success': {
    id: 'scope-management.scope.owners.add.success',
    defaultMessage: "Scope owner added successfully",
    description: 'Success message to be displayed when the Role is updated successfully'
  },
  'scope-management.scope.edit.success': {
    id: 'scope-management.scope.edit.success',
    defaultMessage: 'Scope edited successfully',
    description: 'Success message to be displayed when the Role is updated successfully'
  },
  'scope-management.scope.edit.failed': {
    id: 'scope-management.scope.edit.failed',
    defaultMessage: "Couldn't edit scope. Try again.",
    description: 'Error message to be displayed when the Role edit fails'
  },
});

export default t;
